import React from 'react'
import { Avatar, Grid } from '@mui/material'
import { UseFormReturn, useWatch } from 'react-hook-form'
import CardActions from '../../../components/CardActions'
import { SectionBox } from '../../../components/FieldView'
import { AsyncSelect, ControlledDatePicker } from "../../../../../components/forms";
import { useLoadOptions } from "../../../../../hooks/useLoadOptions";
import { useNOTESSectorComercialTipos, useNOTESUnidadNegocio } from "../hooks/useNOTESCache";
import { EntityWithIdAndDescriptionFields, EntityWithIdFields, SectorComercialFields } from 'src/types';
import { OperacionNOTESFields } from '../types/fields';
import { HttpCacheWorkflow } from 'src/http/workflow/httpCacheWorkflow';
import { SistemaPrincipalFields } from "src/types/workflow/cache";
import { OperacionAFOPUFields } from '../../afopu/types/fields';

interface SeccionNOTESDatosOperacionProps {
  formMethods: UseFormReturn<any>
  codSistema: number,
  codPais: number
}

export const SeccionNuevoNOTESDatosOperacion = ({ formMethods, codSistema, codPais }: SeccionNOTESDatosOperacionProps) => {
  const { control } = formMethods
  const unidadNegocioHook = useNOTESUnidadNegocio(codPais, codSistema)

  const loadUnidadNegocio = useLoadOptions({
    data: unidadNegocioHook.unidadNegocio,
    loading: unidadNegocioHook.isLoading,
    isError: unidadNegocioHook.isError,
    error: unidadNegocioHook.error
  });

  const watchedUnidadNegocio = useWatch({ control: control, name: OperacionAFOPUFields.CodUnidadNegocio });

  const sectorComercialTipos = useNOTESSectorComercialTipos(watchedUnidadNegocio, codSistema);
  const loadSectorComercial = useLoadOptions({
    data: sectorComercialTipos.sectorComercialTipos,
    loading: sectorComercialTipos.isLoading,
    isError: sectorComercialTipos.isError,
    error: sectorComercialTipos.error
  });

  const opcionesSistemaPrincipal = () => HttpCacheWorkflow.getSistemasPrincipales()
    .then(sis => (
      sis.map(opcion => (
        {
          id: opcion[EntityWithIdFields.Id],
          descripcion: opcion[EntityWithIdAndDescriptionFields.Description],
          icon: <Avatar src={opcion[SistemaPrincipalFields.SrcIcono]} sx={{ height: '20px', width: '20px' }} />
        }
      ))
    ))

  return (
    <CardActions title='Datos Operación' icon='mdi:briefcase-outline' colapsable>
      <SectionBox>
        <Grid item xs={12} md={4}>
          <AsyncSelect
            label={'País'}
            name={OperacionNOTESFields.CodPais}
            loadOptions={opcionesSistemaPrincipal}
            control={control}
            selectNotNulleable
            fullWidth
            disabled
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <AsyncSelect
            label={'Unidad de Negocio'}
            name={OperacionNOTESFields.CodUnidadNegocio}
            valueField={SectorComercialFields.UnidadNegocioCodigo}
            loadOptions={loadUnidadNegocio}
            control={control}
            selectNotNulleable
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <AsyncSelect
            label={'Equipo Comercial'}
            name={OperacionNOTESFields.CodSectorComercial}
            valueField={SectorComercialFields.SectorComercialCodigo}
            loadOptions={loadSectorComercial}
            control={control}
            selectNotNulleable
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <ControlledDatePicker name={OperacionNOTESFields.FechaAprobacion} control={control} label='Fecha Solicitud' />
        </Grid>
        <Grid item xs={12} md={4}>
          <ControlledDatePicker name={OperacionNOTESFields.FechaVencimiento} control={control} label='Fecha Vencimiento' />
        </Grid>
      </SectionBox>
    </CardActions>
  )
}
